
import { selectLangObj } from '../../../reducers/langReducer.js';
import { useDispatch, useSelector } from 'react-redux';

import { selectPersonDetails, selectLoadingPersonDetails, setShowDialog, selectPersonDetailsRbr, selectShowPersonDetailsDialog, selectIsError } from '../../../reducers/personDetailsReducer.js';
import { selectNotes, selectLoadingNotes, selectNotesTip, setTip, selectIsError as selectIsErrorNotes } from '../../../reducers/notesReducer.js';

import { fetchPersonDetails } from '../../../fetch/fetchPersonDetails.js';
import { fetchNotes } from '../../../fetch/fetchNotes.js';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { useEffect } from 'react';

import DetailsDialog from '../DetailsDialog.js';  
import PersonDetails from './PersonDetails.js';

function PersonDetailsDialog() {

  const dispatch = useDispatch();

  const rbr = useSelector(selectPersonDetailsRbr);

  const tip = useSelector(selectNotesTip);  
  var showDialog = useSelector(selectShowPersonDetailsDialog);
  var details = useSelector(selectPersonDetails);
  var notes = useSelector(selectNotes);
  var error = useSelector(selectIsError);
  var errorNotes = useSelector(selectIsErrorNotes);

  useEffect(() => {
    if (showDialog ) {
      dispatch(fetchPersonDetails(rbr));

      dispatch(setTip("П"));  

    }
  },
    [showDialog, rbr]);
    useEffect(() => {
    if (showDialog ) {
  

      dispatch(fetchNotes({rbr, tip}));
    }
  },
    [details]);



  function setShow(value) {
    dispatch(setShowDialog(value)); 

  }

  return (
   <DetailsDialog show={showDialog&&!error&&!errorNotes} error={!details} notes={notes} details={details} titleElement={(details?.ime?(details?.ime+" "):"")+(details?.prezime?details?.prezime:"")} setShowDialog={setShow} >

      <PersonDetails details={details}></PersonDetails>

    </DetailsDialog>

  );
}

export default PersonDetailsDialog;
